/** The 9th-tab prompt (spec §4). Nothing opens or closes until Continue. */
import React from 'react';
import { useShell } from './shellContext';

export const CapPrompt: React.FC = () => {
  const { pending, confirmPending, cancelPending } = useShell();
  if (!pending) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Tab limit reached"
        data-testid="shell-cap-prompt"
        className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl"
      >
        <p className="text-sm text-slate-800">
          Opening this will close "{pending.evictTitle}" (least recently used).
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            data-testid="shell-cap-cancel"
            onClick={cancelPending}
            className="rounded px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100"
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="shell-cap-continue"
            onClick={confirmPending}
            className="rounded bg-indigo-600 px-3 py-1.5 text-sm text-white hover:bg-indigo-700"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default CapPrompt;
